import React from "react";
import ReactHtmlParser from "react-html-parser";
import { useTranslation } from "react-i18next";

interface Props {
  texts: string[];
}

function HintBlock({ texts }: Props) {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="tw-border-none tw-self-stretch tw-bg-transparent tw-justify-start tw-items-start tw-text-left tw-gap-2.5 tw-inline-flex tw-text-gray-500 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">
        {texts.map((text, index) => (
          <p key={index}>{ReactHtmlParser(t(text))}</p>
        ))}
      </div>
    </React.Fragment>
  );
}

export default HintBlock;
